import type { AddressSearchOutput } from "@tillix/api-contract/client-schemas";

export function extractAccountFields(
  account: AddressSearchOutput["results"][number],
) {
  const rawZip = account.address.zip ?? "";
  const zipCode = rawZip.replace(/[^0-9]/g, "").slice(0, 5);

  return {
    externalId: account.contractAccount,
    nameOnAccount: account.fullName ?? "",
    zipCode,
  };
}
